export const environment = {
    production: false,
    apiURL: "https://secure-api-sbox.deloitte.com/api",
    oauth: {
        clientId: 'myprofile',
        issuer: "https://myaccess-sbox.deloitte.com/am/oauth2/realms/root/realms/alpha"
    },
    oauthCallbackPath: '/callback',
    footer: {
        termsOfUse: "https://www.deloitte.com/us/en/legal/terms-of-use.html?icid=bn_terms-of-use",
        privacyCookies: "https://cookienotice.deloitte.com/",
        helpCentre: "https://my.deloitte.com/misc/support",
    },
    alloy: {
        sdkKey: 'b09c702a-1bd0-4117-9088-c3dbb720b7fe',
        production: false,
        journeyToken: 'J-9TwlXSKl7JXQiLvADuZc',
        journeyApplicationToken: '',
    },
}